// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Tum2","buttons":"PendingPaymentAlert_buttons__2p4M6"};